// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__1_pQ1","ThumbZoom":"ChapterPlayer_ThumbZoom__1Zw2Q"};